import { bareDocRouteOptions } from "@/features/docs/bare-doc-redirect";
import { createFileRoute } from "@tanstack/react-router";

// CR-162: component-less. Old bare `/docs/:id` links (AI messages, emails) are
// sent to the document's project URL; the document page itself only mounts
// under /workspaces/$slug/projects/$projectSlug/docs/$docId.
export const Route = createFileRoute("/_authenticated/docs/$docId")(bareDocRouteOptions);
